// extracted by mini-css-extract-plugin
module.exports = {"card":"dashboardListingCard_card__2HQMT","cardBody":"dashboardListingCard_cardBody__2HioJ","cardHeader":"dashboardListingCard_cardHeader__1y3EN"};